import React, { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { TextParagraph } from '@atoms'
import { ApplicationState } from '@store/types'
import { Alert } from '@interco/inter-ui/components/Alert'
import { Page } from '@templates'
import IcChevronRight from '@interco/icons/core/action-navigation/ic_chevron_right'
import IcContract from '@interco/icons/core/files/ic_contract'
import { Colors } from '@utils/Colors'
import routes from '@routes/routes'
import {
  setCheckMessageRevisao,
  setDocumentoRevisao,
  setTitleDocumentoRevisao,
} from '@store/refinanciamento/documentosAssinatura/actions'
import { TipoDocs } from '@store/refinanciamento/listaDocumentos/types'
import Tag from '@utils/Tag'
import { dadosPropostaRequest } from '@store/refinanciamento/proposta/actions'
import { trackingRefin } from '@store/refinanciamento/simulacao/actions'
import { BridgeService } from '@services/bridge'
import { useTrackingRefin } from '@hooks'
import { StepRefin } from '@utils/enums'

import { BoxCustom } from './styles'

const Termos = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useTrackingRefin(StepRefin.TERMOS)

  const { documentos } = useSelector(
    (state: ApplicationState) => state.refinanciamento.documentosAssinatura,
  )
  const enumDocumentos = useSelector(
    (state: ApplicationState) => state.refinanciamento.listaDocumentos,
  )
  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)

  useEffect(() => {
    BridgeService.tac({
      name: 'termos',
      actions: ['ver_termos'],
    })

    if (isApp) {
      Tag.enviarTagueamentoApp({
        screen: 'clt:refin:sign',
        ref_type: '',
        content_action: 'Dado carregado',
        action_id: 'Termos de contratacao',
        section: 'sign',
        sub_section: 'terms',
        step: '',
        scenario: 'Termos de contratacao',
        ref_figma: '2',
      })
    } else {
      Tag.enviarTagueamentoWeb({
        element_action: 'page_loaded',
        element_name: 'Termos de contratacao',
        c_page: window.location.href,
        redirect_url: '',
        section_name: 'payrollloan:refin:sign',
        section: 'sign',
        sub_section: 'terms',
        step: '',
        scenario: 'Termos de contratacao',
      })
    }
  }, [isApp])

  useEffect(() => {
    dispatch(dadosPropostaRequest())
  }, [dispatch])

  return (
    <Page titleHeader="Termos de contratação">
      {documentos.length === 0 ? (
        <Alert title="Erro ao buscar termos" type="error">
          Ocorreu um erro ao buscar os termos, por favor tente novamente.
        </Alert>
      ) : (
        <>
          {documentos.map((item: { idTipoDocumento: TipoDocs | string }) => {
            const document = {
              ...enumDocumentos[item?.idTipoDocumento as TipoDocs],
              idTipoDocumento: item?.idTipoDocumento,
            }
            return (
              document && (
                <BoxCustom
                  key={item?.idTipoDocumento}
                  onClick={() => {
                    dispatch(trackingRefin(StepRefin.CLICK_TERMOS_VISUALIZAR_TERMO))
                    BridgeService.tic({
                      name: 'btn_ver_termos',
                      action: 'ver_termos',
                    })

                    if (isApp) {
                      Tag.enviarTagueamentoApp({
                        screen: 'clt:refin:sign',
                        ref_type: 'botao',
                        content_action: 'Toque',
                        action_id: 'Termo de contratacao',
                        section: 'sign',
                        sub_section: 'terms',
                        step: '',
                        scenario: 'Termo de contratacao',
                        ref_figma: '2',
                      })
                    } else {
                      Tag.enviarTagueamentoWeb({
                        element_action: 'click button',
                        element_name: 'Termo de contratacao',
                        c_page: window.location.href,
                        redirect_url: '',
                        section_name: 'payrollloan:refin:sign',
                        section: 'sign',
                        sub_section: 'terms',
                        step: '',
                        scenario: 'Termo de contratacao',
                      })
                    }

                    dispatch(setDocumentoRevisao(item.idTipoDocumento))
                    dispatch(setCheckMessageRevisao(document.checkMessage))
                    dispatch(setTitleDocumentoRevisao(document.text))
                    navigate(routes.TERMO_VISUALIZACAO)
                  }}
                  actived={false}
                >
                  <IcContract height={24} width={24} color={Colors.GRAY500} />
                  <TextParagraph
                    variant="body-3"
                    style={{
                      width: '70%',
                      color: Colors.GRAY500,
                      fontWeight: 700,
                      alignContent: 'flex-start',
                    }}
                  >
                    {document.text}
                  </TextParagraph>
                  <IcChevronRight height={24} width={24} color={Colors.PRIMARY500} />
                </BoxCustom>
              )
            )
          })}
        </>
      )}
    </Page>
  )
}
export default Termos
